import React from "react";
import { Grid, Col, Row } from "react-styled-flexboxgrid";
import Sidemenu from "../Sidemenu";
import Footer from "../Footer";
import { connect } from "react-redux";
import { getGroup } from "../../actions";
import { sidemenuFooterWrap } from "../componentCommon";
import PetarLubardaText from "./PetarLubardaText";
import NadezdaPetrovicText from "./NadezdaPetrovicText";
import SavaSumanovicText from "./SavaSumanovicText";
import AvangardaText from "./AvangardaText";
import OktobarskiSalonText from "./OktobarskiSalonText";
import MSUText from "./MSUText";

import "../../index.scss";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getGroup: (slug) => dispatch(getGroup(slug)),
});

const artistTextGet = (slug) => {
  switch (slug) {
    case "petar-lubarda":
      return <PetarLubardaText />;
    case "sava-sumanovic":
      return <SavaSumanovicText />;
    case "nadezda-petrovic":
      return <NadezdaPetrovicText />;
    case "muzej-savremene-umetnosti":
      return <MSUText />;
    case "avangarda":
      return <AvangardaText />;
    case "oktobarski-salon":
      return <OktobarskiSalonText />;
    default:
      return null;
  }
};

let AboutArtistText = ({ match, getGroup }) => {
  const groupSlug = match.params.hasOwnProperty("groupSlug")
    ? match.params.groupSlug
    : "";
  getGroup(groupSlug);
  const ArtistText = artistTextGet(groupSlug);
  return ArtistText;
};

AboutArtistText = sidemenuFooterWrap(AboutArtistText);
export default connect(mapStateToProps, mapDispatchToProps)(AboutArtistText);
